
import Header from './Components/Header/Header';
import './Assets/css/index.scss'
import "./Assets/css/home.css"
import Slider from './Components/Header/Slider';
import Stats from './Components/Header/Stats';
import Solution from './Components/Header/Solution';
import Comparison from './Components/Header/Comparison';
import FAQ from './Components/Header/Faq';
import Footer from './Components/Header/Footer';


function App() {
  return (
    <div style={{
      width: "100%"
    }}>
      
      <Header />
      <Slider />
      <Stats/>
      <Solution/>
      <Comparison/>
      <FAQ/>
      <Footer/>
    </div>
  );
}

export default App;
